module.exports = __webpack_public_path__ + "fb28bfb54f77c9037bb068284b9b48e5.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/shop/ppu-hat.png
 ** module id = 471
 ** module chunks = 0
 **/